import { z } from "zod";


export const ContasPagarCopiaSchema = z.object({
    idContasPagar: z.coerce.number().min(1, { message: "Selecione uma conta a pagar" }),
    dataPagamento: z.coerce.date({ invalid_type_error: "Data de pagamento inválida." }),
    titulo: z.coerce.string().optional(),
    tipoData: z.coerce.number().refine((val) => [0, 1, 2].includes(val), {
        message: "Tipo de data inválida.",
    }).default(0),
    nroCopias: z.coerce.number().min(1, { message: "Número de cópias inválido." })
        .max(50, { message: "Número máximo de cópias é 50." }),

});

export type ContasPagarCopiaForm = z.infer<typeof ContasPagarCopiaSchema>;

export const defaultContasPagarCopiaForm: Partial<ContasPagarCopiaForm> = {
    dataPagamento: new Date(),
    tipoData: 0,
    nroCopias: 1,

}